import service from '.';

/**
 * MediaBoxItemRes，媒体盒子分页结果
 */
export interface MediaBoxItemRes {
  /**
   * ID
   */
  id: string;
  /**
   * 链接类型
   */
  linkType?: number;
  /**
   * 媒体ID
   */
  mediaId: string;
  /**
   * 媒体名称
   */
  mediaName: string;
  /**
   * 价格
   */
  price?: number;
  /**
   * 平台
   */
  channelType?: string;
  /**
   * 渠道
   */
  displayChannel?: string;
  /**
   * 渠道编码
   */
  channel?: string;
  /**
   * 媒体状态
   */
  status?: number;
  [property: string]: any;
}

export interface MediaBoxChannelRes {
  /**
   * 渠道编码
   */
  code: string;
  /**
   * 渠道名称
   */
  name: string;
  [property: string]: any;
}

export interface MediaBoxPageReq {
  pageIndex: number;
  pageSize: number;
  mediaName?: string;
  /**
   * 渠道编码
   */
  channels?: string[];
  /**
   * 媒体状态
   */
  statuses?: number[];
  /**
   * 可用性；AVAILABLE 表示状态正常且价格非空
   */
  availability?: 'AVAILABLE';
  /**
   * 最低价格
   */
  minPrice?: number;
  /**
   * 最高价格
   */
  maxPrice?: number;
}

export const mediaBoxApi = {
  list: (data: MediaBoxPageReq) => {
    return service.post<List<MediaBoxItemRes>>('/mediaBox/media-page', data);
  },
  channels: () => {
    return service.get<MediaBoxChannelRes[]>('/mediaBox/channels');
  },
};
